// @ts-nocheck
export var CartridgeType;
(function (CartridgeType) {
    CartridgeType[CartridgeType["ROM"] = 0] = "ROM";
    CartridgeType[CartridgeType["MBC1"] = 1] = "MBC1";
    CartridgeType[CartridgeType["MBC1_RAM"] = 2] = "MBC1_RAM";
    CartridgeType[CartridgeType["MBC1_RAM_BATTERY"] = 3] = "MBC1_RAM_BATTERY";
    CartridgeType[CartridgeType["MBC2"] = 5] = "MBC2";
    CartridgeType[CartridgeType["MBC2_BATTERY"] = 6] = "MBC2_BATTERY";
    CartridgeType[CartridgeType["ROM_RAM"] = 8] = "ROM_RAM";
    CartridgeType[CartridgeType["ROM_RAM_BATTERY"] = 9] = "ROM_RAM_BATTERY";
    CartridgeType[CartridgeType["MMM01"] = 11] = "MMM01";
    CartridgeType[CartridgeType["MMM01_RAM"] = 12] = "MMM01_RAM";
    CartridgeType[CartridgeType["MMM01_RAM_BATTERY"] = 13] = "MMM01_RAM_BATTERY";
    CartridgeType[CartridgeType["MBC3_TIMER_BATTERY"] = 15] = "MBC3_TIMER_BATTERY";
    CartridgeType[CartridgeType["MBC3_TIMER_RAM_BATTERY"] = 16] = "MBC3_TIMER_RAM_BATTERY";
    CartridgeType[CartridgeType["MBC3"] = 17] = "MBC3";
    CartridgeType[CartridgeType["MBC3_RAM"] = 18] = "MBC3_RAM";
    CartridgeType[CartridgeType["MBC3_RAM_BATTERY"] = 19] = "MBC3_RAM_BATTERY";
    CartridgeType[CartridgeType["MBC5"] = 25] = "MBC5";
    CartridgeType[CartridgeType["MBC5_RAM"] = 26] = "MBC5_RAM";
    CartridgeType[CartridgeType["MBC5_RAM_BATTERY"] = 27] = "MBC5_RAM_BATTERY";
    CartridgeType[CartridgeType["MBC5_RUMBLE"] = 28] = "MBC5_RUMBLE";
    CartridgeType[CartridgeType["MBC5_RUMBLE_RAM"] = 29] = "MBC5_RUMBLE_RAM";
    CartridgeType[CartridgeType["MBC5_RUMBLE_RAM_BATTERY"] = 30] = "MBC5_RUMBLE_RAM_BATTERY";
    CartridgeType[CartridgeType["MBC6"] = 32] = "MBC6";
    CartridgeType[CartridgeType["MBC7_SENSOR_RUMBLE_RAM_BATTERY"] = 34] = "MBC7_SENSOR_RUMBLE_RAM_BATTERY";
    CartridgeType[CartridgeType["POCKET_CAMERA"] = 252] = "POCKET_CAMERA";
    CartridgeType[CartridgeType["BANDAI_TAMA5"] = 253] = "BANDAI_TAMA5";
    CartridgeType[CartridgeType["HuC3"] = 254] = "HuC3";
    CartridgeType[CartridgeType["HuC1_RAM_BATTERY"] = 255] = "HuC1_RAM_BATTERY";
})(CartridgeType || (CartridgeType = {}));
//# sourceMappingURL=cartridge-type.enum.js.map